import kaplay from "kaplay";
import "kaplay/global";

kaplay({
  width: 1280,
  height: 960,
  background: "#000000",
  letterbox: true,
  font:"rumeur"
});